export default __webpack_public_path__ + "static/media/blue-arrow.5d9be347.svg";